// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"16914118","879":"dd6a431c"}[chunkId] + ".chunk.js";
};